import FilterDateLast12Months from "./FilterDateLast12Months";
const FilterLastPaymentDate = (props: any) => {
  const before = props?.before;

  return (
    <FilterDateLast12Months
      source="limitLastPaymentDate"
      label="Last Payment Date"
      variant="outlined"
      {...props}
    />
  );
};

export default FilterLastPaymentDate;
